import { useIntl } from "react-intl";

import { DirectBuyStatus } from "../types";

export const useSiteSetupHeaderDetails = (
    directBuyStatus?: DirectBuyStatus
): { title: string; description: string } | null => {
    const intl = useIntl();

    switch (directBuyStatus) {
        case DirectBuyStatus.ORDER_CONFIRMED:
            return {
                title: intl.formatMessage({
                    id: "site-setup-header-order-confirmed-title",
                    defaultMessage: "Your order is confirmed.",
                    description:
                        "site setup title when the user comes to provisioning from direct buy journey and order gets confirmed"
                }),
                description: intl.formatMessage({
                    id: "site-setup-header-order-confirmed-description",
                    defaultMessage: "We’ve sent a confirmation email to ",
                    description:
                        "site setup description stating that an email is sent to the user when order gets confirmed. Here email is the email address of the user"
                })
            };
        case DirectBuyStatus.POST_PROVISIONING:
            return {
                title: intl.formatMessage({
                    id: "site-setup-header-post-provisioning-title",
                    defaultMessage: "Let’s get started",
                    description:
                        "site setup title when the user drops off from the direct buy journey and resumes later on for provisioning via other touch points"
                }),
                description: intl.formatMessage({
                    id: "site-setup-header-post-provisioning-description",
                    defaultMessage:
                        "You’ll need to set up your site before you can use your subscription.",
                    description:
                        "site setup description when the user drops off from the direct buy journey and resumes later asking user to set up site before they can use their subscription."
                })
            };

        default:
            return null;
    }
};
